module.exports = __webpack_public_path__ + "static/img/map-bg.041d51ad.png";